import React from 'react'
import type { Partner } from '../../context/PartnerAuthContext'
import type { PartnerProfile } from '../../context/PartnerAuthContext'

interface PartnerIdentityCardProps {
  partner: Partner
  profile: PartnerProfile
  isAdmin: boolean
  accentColor: string
}

/**
 * Carte "Identité partenaire" — logo, nom, rôle, statut, bandeau couleur.
 */
const PartnerIdentityCard: React.FC<PartnerIdentityCardProps> = ({ partner, profile, isAdmin, accentColor }) => {
  return (
    <div
      data-testid="identity-card"
      style={{
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '0.75rem',
        overflow: 'hidden',
      }}
    >
      {/* Bandeau couleur */}
      <div style={{ height: '6px', background: accentColor }} />

      <div style={{ padding: '1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
          {partner.logo_url ? (
            <img
              src={partner.logo_url}
              alt={partner.name}
              style={{
                width: '56px',
                height: '56px',
                borderRadius: '0.5rem',
                objectFit: 'cover',
                border: '2px solid #e2e8f0',
              }}
            />
          ) : (
            <div
              style={{
                width: '56px',
                height: '56px',
                borderRadius: '0.5rem',
                background: accentColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '1.4rem',
                fontWeight: '700',
              }}
            >
              {partner.name.charAt(0).toUpperCase()}
            </div>
          )}
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: 0, fontSize: '1.15rem', fontWeight: '600', color: '#1e293b' }}>
              {partner.name}
            </h3>
            <p style={{ margin: '0.15rem 0 0 0', fontSize: '0.9rem', color: '#64748b' }}>
              {profile.full_name || profile.email}
            </p>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          {/* Badge rôle */}
          <span
            data-testid="role-badge"
            style={{
              display: 'inline-block',
              padding: '0.2rem 0.6rem',
              borderRadius: '9999px',
              fontSize: '0.78rem',
              fontWeight: '600',
              color: isAdmin ? '#1e40af' : '#475569',
              background: isAdmin ? '#dbeafe' : '#f1f5f9',
            }}
          >
            {isAdmin ? 'Admin' : 'Membre'}
          </span>

          {/* Badge statut */}
          <span
            data-testid="status-badge"
            style={{
              display: 'inline-block',
              padding: '0.2rem 0.6rem',
              borderRadius: '9999px',
              fontSize: '0.78rem',
              fontWeight: '600',
              color: partner.status === 'ACTIVE' ? '#065f46' : '#991b1b',
              background: partner.status === 'ACTIVE' ? '#d1fae5' : '#fee2e2',
            }}
          >
            {partner.status === 'ACTIVE' ? '✅ Actif' : '❌ Désactivé'}
          </span>
        </div>
      </div>
    </div>
  )
}

export default PartnerIdentityCard
